module.exports = __webpack_public_path__ + "img/r1c1.63059a51.jpg";